import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoCaAnTruongActionTypes } from "../../action-types/thuc-don/IFoCaAnTruongActionTypes";
import { IFoCaAnTruongReducer } from "../../page-state-model/thuc-don/IFoCaAnTruongReducer";
const iniState: IFoCaAnTruongReducer = {
    status: ePageBaseStatus.is_not_initialization,
    foCaAnTruongs: [],
    foCaAnTruongsVm: []

}
export const foCaAnTruongReducer = (state: IFoCaAnTruongReducer = iniState, action: IFoCaAnTruongActionTypes): IFoCaAnTruongReducer => {
    switch (action.type) {
        case "CA_AN_TRUONG_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CA_AN_TRUONG_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAnTruongsVm: action.payload
            }
        case "CA_AN_TRUONG_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAnTruongsVm: []
            }
        case "CA_AN_TRUONG_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CA_AN_TRUONG_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAnTruongsVm: action.payload
            }
        case "CA_AN_TRUONG_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAnTruongsVm: []
            }
        case "CA_AN_TRUONG_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "CA_AN_TRUONG_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CA_AN_TRUONG_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "CA_AN_TRUONG_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "CA_AN_TRUONG_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CA_AN_TRUONG_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "CA_AN_TRUONG_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CA_AN_TRUONG_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}